import React from 'react';
import clsx from 'clsx';

import { Grid, GridNav, List, Item } from './wrappers';
import NavButton from '../NavButton';
import { GridView } from '../../preload/pages/CategoryPage/Providers/ViewSettingsProvider';

interface IProductGrid {
  children: React.ReactNode;
  centerItems?: boolean;
  scrollRef?: React.MutableRefObject<HTMLUListElement | null>;
  ignoreContainerLtMd?: boolean;
  overflowScroll?: 'always' | 'LtMd';
  onClickPrev?: () => void;
  onClickNext?: () => void;
  productView?: GridView;
}

export const ProductGrid = ({
  children,
  centerItems,
  scrollRef,
  ignoreContainerLtMd,
  overflowScroll,
  onClickPrev,
  onClickNext,
  productView,
}: IProductGrid) => (
  <Grid
    className={clsx(
      overflowScroll === 'always' && 'overflow-scroll-always',
      overflowScroll === 'LtMd' && 'overflow-scroll-ltmd',
      ignoreContainerLtMd && 'ignore-container-lt-md',
    )}>
    <List
      className={clsx(
        centerItems && 'center-items',
        overflowScroll === 'always' && 'horizontal-view',
        productView,
      )}
      ref={scrollRef}>
      {children}
    </List>
    {overflowScroll === 'always' && (
      <>
        {onClickPrev && (
          <GridNav className="dir-prev">
            <NavButton onClick={onClickPrev} title="Föregående produkt" dir="prev" />
          </GridNav>
        )}
        {onClickNext && (
          <GridNav className="dir-next">
            <NavButton onClick={onClickNext} title="Nästa produkt" dir="next" />
          </GridNav>
        )}
      </>
    )}
  </Grid>
);

interface IProductGridItem {
  children: React.ReactNode;
  doubleWidth?: boolean;
  productView?: GridView;
}

export const ProductGridItem = ({ children, doubleWidth, productView }: IProductGridItem) => (
  <Item className={clsx(doubleWidth && 'double-width', productView)}>{children}</Item>
);
